module.exports = __webpack_public_path__ + "static/media/1.5bd84928.png";